import { images } from '@/asset';
import BoldLargeText from '@/components/BoldLargeText';
import { BlockStack, Button } from '@shopify/polaris';
import { memo, useEffect } from 'react';
import { IProps } from '.';
import { preloadImage } from '@/helpers/file';

const Step1 = (props: IProps) => {
  useEffect(() => {
    preloadImage(images.welcome);
  }, []);
  return (
    <div className="step-1">
      <div className="step-content">
        <div className={`est-welcome-description`}>
          <div className="mt-16 content-center">
            <BoldLargeText alignment="center">Reduce “When will I receive order?” inquiries</BoldLargeText>
          </div>
          <div className="mt-8 content-center">
            <BoldLargeText alignment="center">Let customers make faster and confident buying decisions</BoldLargeText>
          </div>
        </div>
        <div className="footer-buttons mt-16">
          <Button variant={'primary'} onClick={props.handleNext}>
            Set up first rule
          </Button>
          <div className="mt-8">
            <Button variant="tertiary" disabled={props.isDisabled} onClick={props.handleFinish} fullWidth>
              Skip
            </Button>
          </div>
        </div>

        <BlockStack inlineAlign="center">
          <img className="welcome-img" alt="welcome img" src={images.welcome} loading="eager" />
        </BlockStack>
      </div>
    </div>
  );
};

export default memo(Step1);
